module.exports = __webpack_public_path__ + "img/icon_flag-w.d2f3fd69.svg";